export default {
  "missing-fields-description": "Les informations suivantes manquent :",

  types: {
    property_taxes: "Taxes foncières",
    identity_document: "Document d'identité",
    bank_identity_statement: "RIB du demandeur",
    ccpi_geocoordinates: "Emplacement du CCPI existant",
    resale_agreement_contract_number: "Numéro du contrat BTA existant",
    resale_agreement_signature: "Signature du contrat d'achat",
    grid_connection_type: "Type de branchement",
    electricity_bill: "Facture d’électricité",
    string_diagram: "Plan de chaînage",
    inverters: "Onduleur(s)",
    wiring_diagram: "Schéma unifilaire électrique",
    company_siret: "SIRET",
    company_legal_name: "Nom légal de l'entreprise",
    panel: "Panneaux",
    consumption_regime: "Régimes de raccordement",
    images: "Photographies de la surface",
    mandate_signed: "Signature du mandat de représentation",
    preliminary_environmental_impact_study: "Etude de cas par cas",
    manual_uploaded_consuel: "Avis de conformité Consuel",
    manual_uploaded_mayor_confirmation:
      "Récépissé de dépôt OU l’autorisation de l’urbanisme",
    manual_uploaded_mayor: "Avis de non-opposition Urbanisme",
    electrical_safety_inspection_agency: "Bureau de contrôle agréé",
    property_activity: "Activité du site",
    presentation_options: "Étude sans proposition",
    enedis_consumption_permission:
      "Accord du client pour analyse courbe de charge",
    technical_images: "Photos du tableau (CCPI) & disjoncteur (AGCP)",
    electrical_specification_conformity: "Notes de calcul",
    mppt_ports: "Chaînage des panneaux",
    number_panels: "Nombre de panneaux",
    application_type: "Type de formulaire de demande d'urbanisme",
    previous_installation_date: "Date de l’installation existante",
    previous_system_size: "Ancienne installation puissance",
    environmental_impact_study: "Etude d'impact",
    hardware_specification_list: "Bon de travaux",
    inverter_power_regulator_certificate: "Attestation de bridage",
    inverter_power_regulator_type: "Régulateur secteur",
    active_power_regulator: "Régulation de puissance active",
    consumption_meter_geocoordinates: "Emplacement du compteur existant",
    other_consumption_meter_owners: "Veuillez ajouter au moins un propriétaire",
    existing_consumption_meter_relationship:
      "Souhaitez-vous raccorder l’installation",
    annual_production: "Productibilité moyenne annuelle",
    inverter_stringing: "Type de schéma",
    panel_layout_description: "Description du calepinage",
    electrical_panel_protection: "Dispositif de protection",
    consumption_meter_solar_system_connection_type: "Branchement de la production à la consommation",
    installation_date: "Date de la pose",
    current_on_battery_cable_protection:
      "Courant du câble de protection batterie",
    battery_ventilation: "Ventilation de(s) batterie(s)",
    batteries: "Batterie",
    storage_system_safety_mechanism:
      "Protection distribution DC de(s) batterie(s)",
    storage_system_earthing_safety_system_type:
      "Mise en œuvre d’un Schéma de Liaisons à la Terre SLT",
    electrical_safety_inspection_report_signed_quote:
      "Devis de l’organisme de contrôle (signé)",
      electrical_safety_inspection_report:
      "Rapport de contrôle de conformité DRE",
    transformer_high_tension_cable_size: "Sections des câbles HTA",
    transformer_high_tension_cable_length: "Longueurs des câbles HTA",
    transformer_energisation_method:
      "Mise sous tension du transformateur d’évacuation",
    transformer_technical_specification: "Fiches techniques du transformateur",
    transformer_existing_images: "Photos de signalétique du transformateur",
    transformer_geocoordinates: "Emplacement du transformateur",
    grid_service_provider: "Fournisseur de services de réseau",
    system_size: "Taille du système",
    mandate: "mandat",
    battery_cable_protection: "câble de protection batterie",
    grid_connection_bank_security_deposit: 'Garantie financière',
    injection_power_exceeds_system_size: " Puissances incohérentes (entre kWc et kVA)",
  },
}
